//
// ReportSession.js
// vav
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "@sas-dvr/ltjs-transport/models/local/Report";
import "@sas-dvr/ltjs-bird/controllers/ReportController";
import "@sas-dvr/ltjs-bird/util/SASReportConfiguration";
import "@sas-dvr/ltjs-transport/depot/ReportManager";
import "../models/reportSession/DebugInfo";
import "@sas-dvr/ltjs-transport/models/media/PrintSetup";

var ReportSession = createModule("vav::ReportSession", [], EventDispatcher, [
    {
        REPORT_OPENING: 240012,
        STATE_RESET: 240010,
        STATE_NOT_SAVED: 240000,
        REPORT_OPENED: 240013,
        STATE_SAVED: 240009,
        REPORT_CLOSED: 240014,
        STATE_NOT_RESET: 240002,
        REPORT_NOT_DELETED: 240004,
        REPORT_SAVED: 240011,
        STATE_NOT_SUPPORTED: 240001,
        REPORT_DELETED: 240015,
        REPORT_NOT_SAVED: 240003,
    },
    ,
    ,
    {
        reportManager: 1,
        autoSaveIntervalInSeconds: 6,
        report: 1,
        reportController: 1,
        SASReportConfiguration: 1,
        autoSavePrimaryState: 2,
    },
    {
        openReport: [0],
        savePrimaryState: [0],
        resetPrimaryStateToDefault: [0],
        closeReport: [0],
        createPrintSetup: [1],
        renameReport: [0,7],
        saveReport: [0],
        hasPrimaryStateChangedSinceLastSave: [2],
        canResetState: [2],
        canSaveReport: [2],
        canSaveState: [2],
        isReportOpen: [2],
        getSerializedReportForSave: [7,1],
        cancelPrinting: [0],
        _printReport_o: [0,1],
        saveReportAs: [0,1,7],
        _printReport_os: [0,1,7],
        saveSASReportAs: [0,1,7,1],
        getDebugInfo: [1],
    },
    {
        _create: [4,1,1],
    },
    ["printReport"],
]);
export default ReportSession;
